<template>
  <div class="ma-8">
    <a @click="$router.go(-1)" class="d-flex align-center ai-back">
      <v-icon right class="page-description ml-0 mr-2">mdi-chevron-left</v-icon> Назад
    </a>
    <BreadCrumbs :items="breadcrumbs" class="mt-3 ml-2 ai-breadcrumps"/>
    <h2 class="page-title mb-8 mt-1">{{ +$route.params.id ? 'Редактировать проект' : 'Добавить проект'}}</h2>

    <div v-if="loading.loadProject">
      Загрузка...
      <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
    </div>
    <div v-else-if="!curProject" >
      Проект не найден
    </div>
    <v-card v-else class="appproject-maincard">
      <v-card-title>
        <h4 class="mt-1 mr-10" style="word-break: normal;">
          {{ titles[tab] }}
        </h4>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab" class="transparent">
          <v-tab-item>
            <ProjectStep1 @next="next()"/>
          </v-tab-item>
          <v-tab-item>
            <ProjectStep2 @next="next()" @back="back()"/>
          </v-tab-item>
          <v-tab-item>
            <ProjectStep3 @next="next()" @back="back()"/>
          </v-tab-item>
          <v-tab-item>
            <ProjectStep4 @next="next()" @back="back()"/>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import ProjectStep1 from './ProjectStep1';
import ProjectStep2 from './ProjectStep2';
import ProjectStep3 from './ProjectStep3';
import ProjectStep4 from './ProjectStep4';

export default {
  name: 'EditProjectPage',
  components: {
    ProjectStep1, ProjectStep2, ProjectStep3, ProjectStep4
  },
  data: () => ({
    tab: 0,
    titles: ['Шаг 1. Описание проекта', 'Шаг 2. Роли в проекте (должности)', 'Шаг 3. Требования к кандидатам', 'Шаг 4. Подобрать кандидатов'],
  }),
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.loadProject(id)
      }
    },  
  },
  computed: {
    ...mapGetters({
      loading: 'ai/hrprojects/loading',
      items: 'ai/hrprojects/items',
      curProject: 'ai/hrprojects/curProject',
    }),
    breadcrumbs() {
      return [
        { title: 'AI-эксперт', url: '/ai?tab=0' },
        { title: 'Проекты HR', url: '/ai?tab=1' },
        { title: +this.$route.params.id ? 'Редактировать проект' : 'Добавить проект' },
      ]
    }
  },
  methods: {
    ...mapActions({
      loadProject: 'ai/hrprojects/loadProject',
    }),
    back() {
      if (this.tab > 0)
        this.tab--;
    },
    next() {
      if (this.tab < this.titles.length-1)
        this.tab++;
      else if (this.tab === this.titles.length-1) {
        this.$router.push('/ai?tab=1');
      }
    },
  }
}
</script>

<style scoped>

.appproject-maincard {
  width: fit-content;
}

</style>
